// ═══════════════════════════════════════════════════════════════
// monetizationAnalytics.ts — FACADE
// All data re-exported from adminAnalyticsUnified.ts (single source of truth)
// ═══════════════════════════════════════════════════════════════

import {
  type AnalyticsKpi,
  type PeriodData as UnifiedPeriodData,
  type TopItem as UnifiedTopItem,
  revenueKpis as unifiedRevenueKpis,
  performanceKpis as unifiedPerformanceKpis,
  unifiedTops,
  type TimePeriod as UnifiedTimePeriod,
  monetizationTimePeriodLabels as unifiedMonetizationTimePeriodLabels,
  getRevenueAnalytics as unifiedGetRevenueAnalytics,
} from './adminAnalyticsUnified';

// ── Types (backward compatible) ──
export type MonetizationTimePeriod = UnifiedTimePeriod;
export type MonetizationPeriodData = UnifiedPeriodData;
export type MonetizationKpi = AnalyticsKpi;
export interface TopMonetizationItem extends UnifiedTopItem {
  extraLabel?: string;
  extraValue?: string;
}
export interface MonetizationTopsData {
  campanas: TopMonetizationItem[];
  patrocinadores: TopMonetizationItem[];
  marketplace: TopMonetizationItem[];
}
export interface MonetizationAnalyticsData {
  tops: MonetizationTopsData;
}

// ── Constants ──
export const monetizationTimePeriodLabels = unifiedMonetizationTimePeriodLabels;
export const revenueKpis: MonetizationKpi[] = unifiedRevenueKpis;
export const performanceKpis: MonetizationKpi[] = unifiedPerformanceKpis;

// ── Helpers ──
export function getMonetizationAnalytics(): MonetizationAnalyticsData {
  const data = unifiedGetRevenueAnalytics();
  return {
    tops: {
      campanas: data.tops.campanas as TopMonetizationItem[],
      patrocinadores: data.tops.patrocinadores as TopMonetizationItem[],
      marketplace: data.tops.marketplace as TopMonetizationItem[],
    },
  };
}